import { background } from '@chakra-ui/react';
import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import Navbar from '../Navbar';
import Footer from '../Footer';


let cardCount5 = 0;
let cardToLood5;
let removedElements5 = [];

export default function FormCV5() {

    document.body.style = 'background: white;';


    const [cardcnt1, setcardcnt] = useState(0)

    useEffect(() => {

    }, [])

    const additem = () => {

        if ((cardCount5 - removedElements5.length) < 4) {
            cardCount5 += 1;
            setcardcnt(cardCount5);


            // setcardToLoad(<>{cardToLoad}
            cardToLood5 = `
          <div id="p${cardCount5}">
              <span id="b${cardCount5}" style="display:none">${cardCount5}</span>
              
  
              <div style="display: flex;flex-direction: row;justify-content:center;align-items: center;">
                <div class="col">
                    <label for="ach0" class="form-label"></label>
                    <input id="ach${cardCount5}" type="text" class="form-control" placeholder="Achievements" />
                </div>
                <div style="margin-top: 28px;cursor:pointer;"> <span class="material-symbols-outlined" id="deleteElement${cardCount5}">delete</span></div>
                 
            </div>
          </div>
              
          `

            const ele = document.createElement('div');
            ele.innerHTML = cardToLood5;
            document.getElementById("addnew5").appendChild(ele);

            document.getElementById(`deleteElement${cardCount5}`).addEventListener("click", () => {
                const cardNumber = document.getElementById(`b${cardcnt1 + 1}`);
                const cardElement = document.getElementById(`p${cardcnt1 + 1}`);

                removedElements5.push(Number.parseInt(cardNumber.textContent))
                cardElement.style.display = "none";



            })
        }
        else {
            alert("More than 5 achievements are not allowed in current version")
        }



    }

    // const displayEle = () => {
    //   console.log("Elements are ")
    //   removedElements4.forEach(element => {
    //     console.log(element, " ", typeof element)
    //   });
    // }

    const loadToLocalStorage = () => {

        const ObjOfElements5 = []

        for (let i = 0; i <= cardCount5; i++) {
            if (!(removedElements5.includes(Number.parseInt(document.getElementById(`b${i}`).textContent)))) {
                ObjOfElements5.push({
                    achievements: document.getElementById(`ach${i}`).value
                })

            }
            else {
                // console.log("not present " + i)
            }


        }

        localStorage.setItem("achievements", JSON.stringify(ObjOfElements5))
        console.log(ObjOfElements5)
        localStorage.setItem("ResumeFrom5HTML", document.getElementById("addnew5").innerHTML)
        //for recovery of code 
        localStorage.setItem("PageValuesItemsForm5", JSON.stringify({
            deletedItems: removedElements5,
            cardCount: cardCount5
        }));
    }


    const populateFormAgain5 = () => {

        if (localStorage.getItem("achievements")) {
            const TotalElementHTMLCode5 = localStorage.getItem("ResumeFrom5HTML");
            const TotalElementHTMLCode5Count = JSON.parse(localStorage.getItem("achievements")).length - 1;

            document.getElementById("addnew5").innerHTML = TotalElementHTMLCode5;

            cardCount5 = TotalElementHTMLCode5Count;
            setcardcnt(TotalElementHTMLCode5Count)
            const DataOfElem5 = JSON.parse(localStorage.getItem("achievements"))
             
            let LoadObj = JSON.parse(localStorage.getItem("PageValuesItemsForm5"));

            //initialization
            cardCount5 = LoadObj.cardCount;
            removedElements5 = LoadObj.deletedItems;

            let count = 0;
            for (let j = 0; j <= cardCount5; j++) {

                if ((removedElements5.includes(Number.parseInt(document.getElementById(`b${j}`).textContent)))) {
                } else {
                    document.getElementById(`ach${j}`).value = DataOfElem5[count++].skill
                    if (j !== 0) {

                        document.getElementById(`deleteElement${j}`).addEventListener("click", () => {
                            removedElements5.push(Number.parseInt(document.getElementById(`b${j}`).textContent));
                            document.getElementById(`p${j}`).style.display = "none";

                            console.log(removedElements5)

                        })
                    }
                     
                }
            }

        }

    }

    useEffect(() => {
        if (localStorage.getItem("achievements")) {
            populateFormAgain5()
        }
    }, [])

    return (
        <>
            <Navbar />
            <div style={{ fontFamily: "Questrial", marginTop: "50px", textAlign: "center" }}>
                <h2>Achievements</h2>
            </div>
            <div id='container' className="container text-center " style={{ width: "800px", marginTop: "30px" , background:"white" }}>

                <div id="addnew5">
                    <div id="p0"></div>
                    <span id="b0" style={{ display: "none" }}>0</span>
                    {/* achievements */}
                    <div style={{ "display": "flex", "flexDirection": "row", "justifyContent": "center", "alignItems": "center" }}>
                        <div class="col">
                            <input id="ach0" type="text" class="form-control" placeholder="Achievement e.g. Hackathon Winner" />
                        </div>
                        <div style={{ marginTop: "28px", width: "24px" }}> <span class=""></span></div>

                    </div>

                </div>
                <button type="button" onClick={additem} style={{ width: "100px", float: "right", marginTop: "20px" }} className="addbtn btn btn-outline-success">Add +</button>
            </div>

            <div style={{ display: "flex", justifyContent: "center", marginTop: "80px", fontFamily: "kanit" , marginBottom:"35vh" }}>

                <Link to="/formcv4" className="btn btn-outline-danger" style={{ marginRight: "50px", width: "180px", fontSize: "18px" }}>Back</Link>

                
                <Link   onClick={loadToLocalStorage} to="/formcv6" className="btn btn-outline-success" style={{ width: "180px", fontSize: "18px" }}>Next</Link>

            </div>
            <Footer />
        </>
    )

}
